import React from "react";

const Transactions = () => {
  const data = [
    {
      transactionId: "abc123",
      createdAt: "2022-05-10",
      name: "John Doe",
      userId: "johndoe123",
      cost: "$50",
    },
    {
      transactionId: "def456",
      createdAt: "2022-05-11",
      name: "Jane Smith",
      userId: "janesmith456",
      cost: "$75",
    },
    {
      transactionId: "ghi789",
      createdAt: "2022-05-12",
      name: "Bob Johnson",
      userId: "1objohnson789",
      cost: "$100",
    },
    {
      transactionId: "jkl012",
      createdAt: "2022-05-13",
      name: "Bob Johnson",
      userId: "2objohnson789",
      cost: "$100",
    },
    {
      transactionId: "mno345",
      createdAt: "2022-05-14",
      name: "Bob Johnson",
      userId: "3objohnson789",
      cost: "$100",
    },
    {
      transactionId: "pqr678",
      createdAt: "2022-05-15",
      name: "Bob Johnson",
      userId: "4objohnson789",
      cost: "$100",
    },
    {
      transactionId: "stu901",
      createdAt: "2022-05-16",
      name: "Bob Johnson",
      userId: "5objohnson789",
      cost: "$100",
    },
    {
      transactionId: "vwx234",
      createdAt: "2022-05-17",
      name: "Bob Johnson",
      userId: "6objohnson789",
      cost: "$100",
    },
    {
      transactionId: "yz0123",
      createdAt: "2022-05-18",
      name: "Bob Johnson",
      userId: "7objohnson789",
      cost: "$100",
    },
  ];

  //Transaction problem

  return (
    <>
      <h1 className="m-5 font-semibold">Transactions</h1>
      <div className="px-5 w-[100vw]  lg:w-full  overflow-x-scroll scrollbar-hidden mb-20">
        <table className="min-w-full divide-y divide-gray-600">
          <thead className="">
            <tr className="text-Light">
              <th scope="col" className="text-start whitespace-nowrap px-2">
                Name
              </th>
              <th scope="col" className="text-start whitespace-nowrap px-2">
                Trans ID
              </th>
              <th scope="col" className="text-start whitespace-nowrap px-2">
                Created At
              </th>
              <th scope="col" className="text-start whitespace-nowrap px-2">
                User ID
              </th>
              <th scope="col" className="text-start whitespace-nowrap px-2">
                Cost
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-700">
            {data.map((item) => (
              <tr key={item.userId}>
                <td className="whitespace-nowrap px-2">{item.name}</td>
                <td className=" whitespace-nowrap px-2">
                  {item.transactionId}
                </td>
                <td className=" whitespace-nowrap px-2">{item.createdAt}</td>
                <td className="whitespace-nowrap px-2">{item.userId}</td>
                <td className="whitespace-nowrap px-2">{item.cost}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Transactions;
